/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BorrowerComparateurV2Response,
  ContractFunnelsResponse,
  CreateSingleQuoteCommand,
  CustomBorrowerContractFunnelCommandDto,
  CustomContractCommandDto,
  CustomContractResponseDto,
  ErrorResponse,
  GenerateMNCAPQuoteResponse,
  GetBorrowerContractFunnelsResponse,
  GlobalContractsCommandDto,
  SelectFunnelsBorrowerCommandDto,
} from '../models/index';
import {
    BorrowerComparateurV2ResponseFromJSON,
    BorrowerComparateurV2ResponseToJSON,
    ContractFunnelsResponseFromJSON,
    ContractFunnelsResponseToJSON,
    CreateSingleQuoteCommandFromJSON,
    CreateSingleQuoteCommandToJSON,
    CustomBorrowerContractFunnelCommandDtoFromJSON,
    CustomBorrowerContractFunnelCommandDtoToJSON,
    CustomContractCommandDtoFromJSON,
    CustomContractCommandDtoToJSON,
    CustomContractResponseDtoFromJSON,
    CustomContractResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GenerateMNCAPQuoteResponseFromJSON,
    GenerateMNCAPQuoteResponseToJSON,
    GetBorrowerContractFunnelsResponseFromJSON,
    GetBorrowerContractFunnelsResponseToJSON,
    GlobalContractsCommandDtoFromJSON,
    GlobalContractsCommandDtoToJSON,
    SelectFunnelsBorrowerCommandDtoFromJSON,
    SelectFunnelsBorrowerCommandDtoToJSON,
} from '../models/index';

export interface CustomizeBorrowerContractFunnelV2Request {
    oldHash: string;
    customBorrowerContractFunnelCommandDto: CustomBorrowerContractFunnelCommandDto;
}

export interface FetchGlobalContractsRequest {
    globalContractsCommandDto: GlobalContractsCommandDto;
}

export interface GenerateDevisSimulationPdfRequest {
    createSingleQuoteCommand: CreateSingleQuoteCommand;
}

export interface GenerateQuickQuoteRequest {
    hash: string;
}

export interface GetBorrowerCustomPricingDataRequest {
    selectFunnelsBorrowerCommandDto: SelectFunnelsBorrowerCommandDto;
}

export interface GetBorrowerCustomPricingDataV2Request {
    selectFunnelsBorrowerCommandDto: SelectFunnelsBorrowerCommandDto;
}

export interface GetBorrowerPricingInitialV2Request {
    selectFunnelsBorrowerCommandDto: SelectFunnelsBorrowerCommandDto;
}

export interface GetFunnelsByRiskIdRequest {
    risqueAssureId: string;
}

export interface UpdateContractPriceRequest {
    customContractCommandDto: CustomContractCommandDto;
}

/**
 * 
 */
export class PricingApi extends runtime.BaseAPI {

    /**
     * Customizes a specific contract funnel for the borrower comparator. The oldHash path parameter identifies the contract funnel to update (resolved from server-side cache). After the update, the pricing is recalculated asynchronously via SignalR. This endpoint returns no body — the frontend receives pricing updates through SignalR events. 
     * Customize a specific borrower contract funnel (v2)
     */
    async customizeBorrowerContractFunnelV2Raw(requestParameters: CustomizeBorrowerContractFunnelV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['oldHash'] == null) {
            throw new runtime.RequiredError(
                'oldHash',
                'Required parameter "oldHash" was null or undefined when calling customizeBorrowerContractFunnelV2().'
            );
        }

        if (requestParameters['customBorrowerContractFunnelCommandDto'] == null) {
            throw new runtime.RequiredError(
                'customBorrowerContractFunnelCommandDto',
                'Required parameter "customBorrowerContractFunnelCommandDto" was null or undefined when calling customizeBorrowerContractFunnelV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comparateurs/emprunteurs/v2/contract-funnel/{oldHash}`.replace(`{${"oldHash"}}`, encodeURIComponent(String(requestParameters['oldHash']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CustomBorrowerContractFunnelCommandDtoToJSON(requestParameters['customBorrowerContractFunnelCommandDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Customizes a specific contract funnel for the borrower comparator. The oldHash path parameter identifies the contract funnel to update (resolved from server-side cache). After the update, the pricing is recalculated asynchronously via SignalR. This endpoint returns no body — the frontend receives pricing updates through SignalR events. 
     * Customize a specific borrower contract funnel (v2)
     */
    async customizeBorrowerContractFunnelV2(requestParameters: CustomizeBorrowerContractFunnelV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.customizeBorrowerContractFunnelV2Raw(requestParameters, initOverrides);
    }

    /**
     * Process global fees and variables selection to generate custom contract responses with tarification details
     * Select global guarantees, fees and variables for contract simulation
     */
    async fetchGlobalContractsRaw(requestParameters: FetchGlobalContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractFunnelsResponse>> {
        if (requestParameters['globalContractsCommandDto'] == null) {
            throw new runtime.RequiredError(
                'globalContractsCommandDto',
                'Required parameter "globalContractsCommandDto" was null or undefined when calling fetchGlobalContracts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comparateurs/custom-global-contrats`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalContractsCommandDtoToJSON(requestParameters['globalContractsCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractFunnelsResponseFromJSON(jsonValue));
    }

    /**
     * Process global fees and variables selection to generate custom contract responses with tarification details
     * Select global guarantees, fees and variables for contract simulation
     */
    async fetchGlobalContracts(requestParameters: FetchGlobalContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractFunnelsResponse> {
        const response = await this.fetchGlobalContractsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates a devis simulation PDF from the cartouche, without persisting any devis or document. Used to offer a quote on an aliment of a draft collective contract.
     * Generate an on-the-fly devis PDF (generic flow, no persisted devis)
     */
    async generateDevisSimulationPdfRaw(requestParameters: GenerateDevisSimulationPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateMNCAPQuoteResponse>> {
        if (requestParameters['createSingleQuoteCommand'] == null) {
            throw new runtime.RequiredError(
                'createSingleQuoteCommand',
                'Required parameter "createSingleQuoteCommand" was null or undefined when calling generateDevisSimulationPdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comparateurs/devis-simulation-pdf`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSingleQuoteCommandToJSON(requestParameters['createSingleQuoteCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateMNCAPQuoteResponseFromJSON(jsonValue));
    }

    /**
     * Generates a devis simulation PDF from the cartouche, without persisting any devis or document. Used to offer a quote on an aliment of a draft collective contract.
     * Generate an on-the-fly devis PDF (generic flow, no persisted devis)
     */
    async generateDevisSimulationPdf(requestParameters: GenerateDevisSimulationPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateMNCAPQuoteResponse> {
        const response = await this.generateDevisSimulationPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate MNCAP quote
     */
    async generateQuickQuoteRaw(requestParameters: GenerateQuickQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateMNCAPQuoteResponse>> {
        if (requestParameters['hash'] == null) {
            throw new runtime.RequiredError(
                'hash',
                'Required parameter "hash" was null or undefined when calling generateQuickQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/comparateurs/emprunteurs/simulation-pdf/{hash}`.replace(`{${"hash"}}`, encodeURIComponent(String(requestParameters['hash']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateMNCAPQuoteResponseFromJSON(jsonValue));
    }

    /**
     * Generate MNCAP quote
     */
    async generateQuickQuote(requestParameters: GenerateQuickQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateMNCAPQuoteResponse> {
        const response = await this.generateQuickQuoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get borrower custom pricing data by risk ID
     */
    async getBorrowerCustomPricingDataRaw(requestParameters: GetBorrowerCustomPricingDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBorrowerContractFunnelsResponse>> {
        if (requestParameters['selectFunnelsBorrowerCommandDto'] == null) {
            throw new runtime.RequiredError(
                'selectFunnelsBorrowerCommandDto',
                'Required parameter "selectFunnelsBorrowerCommandDto" was null or undefined when calling getBorrowerCustomPricingData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comparateurs/custom-global-contrats-emprunteurs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectFunnelsBorrowerCommandDtoToJSON(requestParameters['selectFunnelsBorrowerCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBorrowerContractFunnelsResponseFromJSON(jsonValue));
    }

    /**
     * Get borrower custom pricing data by risk ID
     */
    async getBorrowerCustomPricingData(requestParameters: GetBorrowerCustomPricingDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBorrowerContractFunnelsResponse> {
        const response = await this.getBorrowerCustomPricingDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Optimized version with asynchronous pricing via SignalR. Called when the user modifies parameters in the comparateur (fees, guarantees, loans). Returns updated contract funnels with pricing=null and pricingStatus=Pending. The frontend must reconnect to SignalR to receive the new pricing updates. 
     * Get borrower custom pricing data with async pricing via SignalR (v2)
     */
    async getBorrowerCustomPricingDataV2Raw(requestParameters: GetBorrowerCustomPricingDataV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BorrowerComparateurV2Response>> {
        if (requestParameters['selectFunnelsBorrowerCommandDto'] == null) {
            throw new runtime.RequiredError(
                'selectFunnelsBorrowerCommandDto',
                'Required parameter "selectFunnelsBorrowerCommandDto" was null or undefined when calling getBorrowerCustomPricingDataV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comparateurs/emprunteurs/v2/custom-global`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectFunnelsBorrowerCommandDtoToJSON(requestParameters['selectFunnelsBorrowerCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BorrowerComparateurV2ResponseFromJSON(jsonValue));
    }

    /**
     * Optimized version with asynchronous pricing via SignalR. Called when the user modifies parameters in the comparateur (fees, guarantees, loans). Returns updated contract funnels with pricing=null and pricingStatus=Pending. The frontend must reconnect to SignalR to receive the new pricing updates. 
     * Get borrower custom pricing data with async pricing via SignalR (v2)
     */
    async getBorrowerCustomPricingDataV2(requestParameters: GetBorrowerCustomPricingDataV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BorrowerComparateurV2Response> {
        const response = await this.getBorrowerCustomPricingDataV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Optimized version with asynchronous pricing via SignalR. Returns contract funnels immediately with pricing=null and pricingStatus=Pending. The frontend must connect to the SignalR hub /signalr/comparateur and join the session with the returned sessionId. Pricings are then received via the \"PricingUpdate\" event. 
     * Get borrower contract funnels with async pricing via SignalR (v2)
     */
    async getBorrowerPricingInitialV2Raw(requestParameters: GetBorrowerPricingInitialV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BorrowerComparateurV2Response>> {
        if (requestParameters['selectFunnelsBorrowerCommandDto'] == null) {
            throw new runtime.RequiredError(
                'selectFunnelsBorrowerCommandDto',
                'Required parameter "selectFunnelsBorrowerCommandDto" was null or undefined when calling getBorrowerPricingInitialV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comparateurs/emprunteurs/v2/initial`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectFunnelsBorrowerCommandDtoToJSON(requestParameters['selectFunnelsBorrowerCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BorrowerComparateurV2ResponseFromJSON(jsonValue));
    }

    /**
     * Optimized version with asynchronous pricing via SignalR. Returns contract funnels immediately with pricing=null and pricingStatus=Pending. The frontend must connect to the SignalR hub /signalr/comparateur and join the session with the returned sessionId. Pricings are then received via the \"PricingUpdate\" event. 
     * Get borrower contract funnels with async pricing via SignalR (v2)
     */
    async getBorrowerPricingInitialV2(requestParameters: GetBorrowerPricingInitialV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BorrowerComparateurV2Response> {
        const response = await this.getBorrowerPricingInitialV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tunnels information for a specific branch
     */
    async getFunnelsByRiskIdRaw(requestParameters: GetFunnelsByRiskIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractFunnelsResponse>> {
        if (requestParameters['risqueAssureId'] == null) {
            throw new runtime.RequiredError(
                'risqueAssureId',
                'Required parameter "risqueAssureId" was null or undefined when calling getFunnelsByRiskId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/comparateurs/risque-assure/{risqueAssureId}`.replace(`{${"risqueAssureId"}}`, encodeURIComponent(String(requestParameters['risqueAssureId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractFunnelsResponseFromJSON(jsonValue));
    }

    /**
     * Get tunnels information for a specific branch
     */
    async getFunnelsByRiskId(requestParameters: GetFunnelsByRiskIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractFunnelsResponse> {
        const response = await this.getFunnelsByRiskIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a custom contract simulation with specified tunnel configuration, fees, variables, and guarantees
     * Create a custom contract simulation
     */
    async updateContractPriceRaw(requestParameters: UpdateContractPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomContractResponseDto>> {
        if (requestParameters['customContractCommandDto'] == null) {
            throw new runtime.RequiredError(
                'customContractCommandDto',
                'Required parameter "customContractCommandDto" was null or undefined when calling updateContractPrice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comparateurs/custom-contrat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomContractCommandDtoToJSON(requestParameters['customContractCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomContractResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a custom contract simulation with specified tunnel configuration, fees, variables, and guarantees
     * Create a custom contract simulation
     */
    async updateContractPrice(requestParameters: UpdateContractPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomContractResponseDto> {
        const response = await this.updateContractPriceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
